var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Map, Polyline } from 'leaflet';
import * as TileProvider from './leaflet/TileProvider';
import BaseMap from './base/BaseMap';
import LeafletMarker from './leaflet/LeafletMarker';
import LeafletLocation from './leaflet/LeafletLocation';
var LeafletMap = /** @class */ (function (_super) {
    __extends(LeafletMap, _super);
    function LeafletMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafletMap.prototype.initializeMap = function (userLocation) {
        this.map = new Map(this.container);
        this.map.setView(new LeafletLocation(userLocation).toLeafletLatLng(), 12);
        this.map.scrollWheelZoom.disable();
        TileProvider.OSM_Default.addTo(this.map);
        return this.map;
    };
    LeafletMap.prototype.createUserMarker = function (userLocation) {
        var location = new LeafletLocation(userLocation);
        location.toCircleMarker({
            radius: 10,
            // inner
            fill: true,
            fillColor: '#CCDD00',
            fillOpacity: 1,
            // outer
            color: 'white',
            opacity: 1,
            weight: 2,
        })
            .addTo(this.map)
            .bindPopup('Agilis')
            .openPopup();
    };
    LeafletMap.prototype.createPolyline = function (id, color, locations) {
        new Polyline(locations.map(function (it) { return new LeafletLocation(it).toLeafletLatLng(); }), {
            color: color.length == 0 ? '#ccdd00' : color,
            weight: 8,
            opacity: 1,
            smoothFactor: 1
        }).addTo(this.map);
    };
    LeafletMap.prototype.setCenter = function (location) {
        this.map.panTo(new LeafletLocation(location).toLeafletLatLng());
        this.map.setZoom(14);
    };
    LeafletMap.prototype.createMarkerInternal = function (location, iconData) {
        return new LeafletMarker(location.getPrimaryCategorySlug(), iconData, location).addTo(this);
    };
    return LeafletMap;
}(BaseMap));
export default LeafletMap;
